import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Svalbard (1-31 and 33)
import svalbard1 from '../images/svalbard1.jpeg';
import svalbard2 from '../images/svalbard2.jpeg';
import svalbard3 from '../images/svalbard3.jpeg';
import svalbard4 from '../images/svalbard4.jpeg';
import svalbard5 from '../images/svalbard5.jpeg';
import svalbard6 from '../images/svalbard6.jpeg';
import svalbard7 from '../images/svalbard7.jpeg';
import svalbard8 from '../images/svalbard8.jpeg';
import svalbard9 from '../images/svalbard9.jpeg';
import svalbard10 from '../images/svalbard10.jpeg';
import svalbard11 from '../images/svalbard11.jpeg';
import svalbard12 from '../images/svalbard12.jpeg';
import svalbard13 from '../images/svalbard13.jpeg';
import svalbard14 from '../images/svalbard14.jpeg';
import svalbard15 from '../images/svalbard15.jpeg';
import svalbard16 from '../images/svalbard16.jpeg';
import svalbard17 from '../images/svalbard17.jpeg';
import svalbard18 from '../images/svalbard18.jpeg';
import svalbard19 from '../images/svalbard19.jpeg';
import svalbard20 from '../images/svalbard20.jpeg';
import svalbard21 from '../images/svalbard21.jpeg';
import svalbard22 from '../images/svalbard22.jpeg';
import svalbard23 from '../images/svalbard23.jpeg';
import svalbard24 from '../images/svalbard24.jpeg';
import svalbard25 from '../images/svalbard25.jpeg';
import svalbard26 from '../images/svalbard26.jpeg';
import svalbard27 from '../images/svalbard27.jpeg';
import svalbard28 from '../images/svalbard28.jpeg';
import svalbard29 from '../images/svalbard29.jpeg';
import svalbard30 from '../images/svalbard30.jpeg';
import svalbard31 from '../images/svalbard31.jpeg';
import svalbard33 from '../images/svalbard33.jpeg';

function Svalbard() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images (1-31 and 33, skipping 32)
  const photos = [
    svalbard1, svalbard2, svalbard3, svalbard4, svalbard5, svalbard6,
    svalbard7, svalbard8, svalbard9, svalbard10, svalbard11, svalbard12,
    svalbard13, svalbard14, svalbard15, svalbard16, svalbard17, svalbard18,
    svalbard19, svalbard20, svalbard21, svalbard22, svalbard23, svalbard24,
    svalbard25, svalbard26, svalbard27, svalbard28, svalbard29, svalbard30,
    svalbard31, svalbard33
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇸🇯 Svalbard 2026 🇸🇯</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Svalbard ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Svalbard;